<template>
  <div>
    <v-card class="mb-3">
      <v-card-title class="portal-deep-blue-bg">
        {{ $t("message.infoloc.wheelset", { value: "default" }) }}
      </v-card-title>
      <v-card-text>
        <div class="text-subtitle-2 my-2">
          <b>
            {{ $t("message.magic.date", { value: "default" }) }}:
            {{ wheelsets[0]?.measuredate }}
          </b>
        </div>
        <v-row class="mt-5 ">
          
          <v-col class="text-center d-flex justify-center">
            <v-sheet width="300" class="mx-3">
              
              <div class="d-flex flex-column wheel">
                <!-- wheel measure right -->
                <v-card class="mb-auto" color="rgba(255, 255, 255, 0)" elevation="0">
                  <v-row>
                    <v-col class="schema-text text-left">
                      R:{{ wheelsets[0]?.measures[wheelsetsNums[0]]?.dright }}
                    </v-col>
                    <v-col class="schema-text text-right">
                      R:{{ wheelsets[0]?.measures[wheelsetsNums[1]]?.dright }}
                    </v-col>
                  </v-row>
                </v-card>
                
                <!--wheel nums-->
                <v-card class="mb-auto" color="rgba(255, 255, 255, 0)" elevation="0">
                  <v-row>
                    <v-col class="schema-text text-left pl-7">
                      <b>{{ wheelsetsNums[0] }}</b>
                    </v-col>
                    <v-col class="schema-text">
                      <b>{{ wheelsetsNums[1] }}</b>
                    </v-col>
                  </v-row>
                </v-card>
                
                <!-- wheel measure left -->
                <v-card color="rgba(255, 255, 255, 0)" elevation="0">
                  <v-row>
                    <v-col class="schema-text text-left">
                      L:{{ wheelsets[0]?.measures[wheelsetsNums[0]]?.dleft }}
                    </v-col>
                    <v-col class="schema-text text-right">
                      L:{{ wheelsets[0]?.measures[wheelsetsNums[1]]?.dleft }}
                    </v-col>
                  </v-row>
                </v-card>
              </div>
              <img src="@/assets/wheels.png" height="200" alt="logo" style="display: block; margin: auto; " />
            </v-sheet>
          </v-col>
          <v-col class="text-center d-flex justify-center">
            <v-sheet width="300" class="mx-3">
              
              <div class="d-flex flex-column wheel">
                <!-- wheel measure right -->
                <v-card class="mb-auto" color="rgba(255, 255, 255, 0)" elevation="0">
                  <v-row>
                    <v-col class="schema-text text-left">
                      R:{{ wheelsets[0]?.measures[wheelsetsNums[2]]?.dright }}
                    </v-col>
                    <v-col class="schema-text text-right">
                      R:{{ wheelsets[0]?.measures[wheelsetsNums[3]]?.dright }}
                    </v-col>
                  </v-row>
                </v-card>
                <!--wheel nums-->
                <v-card class="mb-auto" color="rgba(255, 255, 255, 0)" elevation="0">
                  <v-row>
                    <v-col class="schema-text text-left pl-7">
                      <b>{{ wheelsetsNums[2] }}</b>
                    </v-col>
                    <v-col class="schema-text">
                      <b>{{ wheelsetsNums[3] }}</b>
                    </v-col>
                  </v-row>
                </v-card>
                
                <!-- wheel measure left -->
                <v-card color="rgba(255, 255, 255, 0)" elevation="0">
                  <v-row>
                    <v-col class="schema-text text-left">
                      L:{{ wheelsets[0]?.measures[wheelsetsNums[2]]?.dleft }}
                    </v-col>
                    <v-col class="schema-text text-right">
                      L:{{ wheelsets[0]?.measures[wheelsetsNums[3]]?.dleft }}
                    </v-col>
                  </v-row>
                </v-card>
              </div>
              <img src="@/assets/wheels.png" height="200" alt="logo" style="display: block; margin: auto; " />
            </v-sheet>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="mb-3">
      
      <v-card-title class="portal-deep-blue-bg">
        {{ $t("message.aside.history", { value: "default" }) }}
      </v-card-title>
      <v-card-text>
        <v-row class="text-center">
          <v-col>
            <v-data-table :items="wheelsets" :items-per-page="5" dense class="mt-3">
              <template v-slot:header="{ props: {} }">
                <thead>
                  <tr>
                    <th>&nbsp;</th>
                    <template v-for="wheel in wheelsetsNums">
                      <th style="cursor: pointer" :key="wheel.concat('-', 'left')">
                        D LEFT
                      </th>
                      <th style="cursor: pointer" :key="wheel.concat('-', 'right')">
                        D RIGHT
                      </th>
                    </template>
                  </tr>
                </thead>
              </template>
              <template v-slot:body="{ items }">
                <tbody>
                  <tr v-for="item in items" :key="item.measuredate">
                    <td>{{ item?.measuredate }}</td>
                    <td>{{ item?.measures[wheelsetsNums[0]]?.dleft }}</td>
                    <td>
                      {{ item?.measures[wheelsetsNums[0]]?.dright }}
                    </td>
                    <td>{{ item?.measures[wheelsetsNums[1]]?.dleft }}</td>
                    <td>{{ item?.measures[wheelsetsNums[1]]?.dright }}</td>
                    <td>{{ item?.measures[wheelsetsNums[2]]?.dleft }}</td>
                    <td>{{ item?.measures[wheelsetsNums[2]]?.dright }}</td>
                    <td>{{ item?.measures[wheelsetsNums[3]]?.dleft }}</td>
                    <td>{{ item?.measures[wheelsetsNums[3]]?.dright }}</td>
                    <td>
                      <v-icon v-if="checkWo(item)" @click="downloadProtocol(item)">mdi-eye</v-icon>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import MaximoService from "@/services/MaximoService";

export default {
  props: ['wheelsets', 'wheelsetsNums'],
  methods: { 
    checkWo(item) {
      if (item?.doclinksid != null) {
        return true
      }
      return false
    },
    downloadProtocol(item) {
      let file_path = MaximoService.downloadProtocol(item.doclinksid);
      window.open(file_path);
    },

  }
}
</script>